/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */

export interface JaegerPropagatorConfig {
  customTraceHeader?: string;
  customBaggageHeaderPrefix?: string;
}
